var exports = {
  "BG": "ListItemContainer__R5AX2c",
  "Zq": "ListItemText__tnpfL1",
  "PO": "iconSuccess__EKjFUi",
  "m$": "iconFailure__-cfNEp",
  "Sx": "titleBold__WWww3v",
};

module.exports = exports;
